// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31VPm","colBig":"styles_colBig__1fLF7","colSmall":"styles_colSmall__IMFEl"};